var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn place-order-btn btn-primary",class:_vm.checkoutValidation.success || _vm.isInvalidTimeslot ? '' : 'disabled',on:{"click":_vm.openProceedConfirmation}},[_vm._v("\n  Start checkout\n")])}
var staticRenderFns = []

export { render, staticRenderFns }